import { Injectable } from '@angular/core';


import { Baseservice } from './baseservice'

import { AuthenticationService } from './authentication.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class StatusService extends Baseservice {

    constructor(http: HttpClient, authentication: AuthenticationService) {
        super('status', http, authentication);
    }


  checkById(id: number) {
    return this.getRequest(`${this.url}/check/id/${id}`);
  }

  statusesDDL(ctrlKey: number=1) {
    return this.getRequest(`${this.url}/list/${ctrlKey}`);
  }
  
}
